"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var _ActionTypes2 = require("FileManagerCore/actions/ActionTypes");

var ImageOptimizationSettings = _interopRequireWildcard(require("../enums/ImageOptimizationSettings"));

var defaultState = _immutable.default.Map({
  imageOptimizationSetting: ImageOptimizationSettings.MEDIUM
});

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      imageOptimizationSetting = action.imageOptimizationSetting,
      selectedFile = action.selectedFile;

  switch (type) {
    case _ActionTypes2.SELECT_FILE:
      if (selectedFile) {
        return defaultState;
      }

      return state;

    case _ActionTypes.SELECT_IMAGE_OPTIMIZATION_SETTING:
      return state.set('imageOptimizationSetting', imageOptimizationSetting);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;